import { createInstance } from '@/helpers/api/base'
import { IUserInfoResponse } from '@/types/user'
import { useAppQuery } from '@/helpers/api/query'

export const useGetUserInfo = () => {
    return useAppQuery<IUserInfoResponse>({
        queryKey: ['user-info'],
        queryFn: () =>
            createInstance({
                url: '/user-info',
                method: 'GET',
            }),
        refetchOnMount: false,
    })
}
